import removeHashtag from "components/ProjectSpecificComponents/Functions/removeHashtag"
import { TOnChangeText } from "components/ProjectSpecificComponents/Interfaces/GlobalInterface"
import React, { useMemo } from "react"
import styled from "styled-components"
import HyperDiv from "../HyperDiv/HyperDiv"

interface Props {
	value?: string
	defaultValue?: string
	maxLength?: number
	onChangeText?: TOnChangeText
	containerStyle?: React.CSSProperties
	inputStyle?: React.CSSProperties
	selectedColor?: string
}

/**
 * Input with a hashtag "icon" to the left of the text input field and color box to the right.
 * It does not currently add a hashtag to the output,
 * but does indicate that hashtag already exists.
 */
const InputWithHashtagIndicationAndColorBox = ({
	value,
	defaultValue,
	maxLength,
	onChangeText,
	containerStyle,
	inputStyle,
	selectedColor,
}: Props) => {
	useMemo(() => (value = defaultValue), [defaultValue])
	return (
		<HyperDiv
			style={{
				height: 38,
				outlineColor: "var(--blue)",
				...containerStyle,
			}}
			direction="row"
		>
			<HashtagContainer>
				<div className="fill-cter center-x-y non-draggable">#</div>
			</HashtagContainer>
			<CustomInput
				style={{
					width: "100%",
					...inputStyle,
				}}
				type="text"
				maxLength={maxLength}
				value={removeHashtag(value)}
				defaultValue={removeHashtag(defaultValue)}
				onChange={(e) => onChangeText && onChangeText(e.target.value)}
			/>
			<ColorContainer style={{ backgroundColor: defaultValue ?? "red", color: "red" }} />
		</HyperDiv>
	)
}

export default InputWithHashtagIndicationAndColorBox

const CustomInput = styled.input`
	height: 38px;
	background-color: var(--white);
	outline: none;
	padding-left: 8px;
	border-top: 1px solid var(--gray-c2);
	border-bottom: 1px solid var(--gray-c2);
	border-left: none;
	border-right: none;

	// Text
	color: inherit;
	font-family: inherit;
	font-size: 14px;
	font-weight: 400;
	line-height: 1.6;
	text-transform: none;
	word-wrap: normal;

	// Animation
	transition: 0.2s var(--default-slide-transition-fn);
	transition-property: border-color; ;
`

const ColorContainer = styled.div`
	height: 38px;
	width: 38px;
	border-radius: 0 5px 5px 0;
	border: 1px solid var(--gray-c2);
`
const HashtagContainer = styled.div`
	height: 38px;
	width: 38px;
	border: 1px solid var(--gray-c2);

	border-radius: 5px 0 0 5px;
	color: var(--some-other-kind-of-gray);
`
